import React from "react";
import { TaskInboxWithResizable } from "./TaskInboxWithResizable";
import { RightMainContents } from "../RightMainContents";
import { Flex } from "@chakra-ui/react";
import { pxToRem } from "../../utils/styles/size";
import { viewModeState } from "../../recoil/view/viewMode";
import { useRecoilValue } from "recoil";

const DesktopMainView = ({
  hasBlocksSynchronizedWithGoogle,
}: {
  hasBlocksSynchronizedWithGoogle: boolean;
}) => {
  const viewMode = useRecoilValue(viewModeState);
  return (
    <Flex
      flex={1}
      bg="#0C0D0D"
      h="100%"
      p={pxToRem(7)}
      gap={2}
    >
      {viewMode === "calendar" && (
        <TaskInboxWithResizable hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle} />
      )}
      <RightMainContents hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle} />
    </Flex>
  );
};

export default DesktopMainView;
